// Pop-up: register an unknown plate to a customer (pre-filled from the sheet row).
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.

export default function AddPlateModal({ addPlateBusy, addPlateRow, confirmAddPlate, pending, refLists, refresh, setAddPlateBusy, setAddPlateRow }) {
  return (
    <>
      {addPlateRow && (
        // Backdrop closes the modal UNLESS we're mid-save. The check is
        // here on the backdrop click (handler-level) — additional gate is
        // setAddPlateBusy(true) running BEFORE the await in confirmAddPlate,
        // so even a millisecond-fast tap can't slip through.
        <div className="modal-backdrop" onClick={() => !addPlateBusy && setAddPlateRow(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 420, maxWidth: 560 }}>
            <h3 style={{ marginTop: 0 }}>Add plate to registry?</h3>
            <p>Adds the following plate to the registry. Future pending rows for this plate will auto-resolve.</p>
            <table className="fs-table tidy" style={{ marginBottom: '0.75rem' }}>
              <tbody>
                <tr><td style={{ color: '#666' }}>Plate</td><td>
                  <input value={addPlateRow.licensePlate || ''}
                         onChange={e => setAddPlateRow(prev => ({ ...prev, licensePlate: e.target.value.toUpperCase().replace(/\s+/g, '') }))}
                         style={{ fontFamily: 'monospace', fontWeight: 600, padding: '3px 6px', width: '12em' }} />
                </td></tr>
                <tr><td style={{ color: '#666' }}>Customer</td><td>
                  <input list="add-plate-customers" value={addPlateRow.customer || ''}
                         onChange={e => setAddPlateRow(prev => ({ ...prev, customer: e.target.value }))}
                         placeholder="(required — pick or type)"
                         style={{ padding: '3px 6px', width: '20em' }} />
                  <datalist id="add-plate-customers">
                    {(refLists.customers || []).map(c => <option key={c} value={c} />)}
                  </datalist>
                </td></tr>
                <tr><td style={{ color: '#666' }}>Tank size (m³)</td><td>
                  <input type="number" step="0.1" value={addPlateRow.tankSize ?? ''}
                         onChange={e => setAddPlateRow(prev => ({ ...prev, tankSize: e.target.value }))}
                         placeholder="e.g. 10"
                         style={{ padding: '3px 6px', width: '8em' }} />
                </td></tr>
                <tr><td style={{ color: '#666' }}>Truck #</td><td>
                  <input value={addPlateRow.truckNumber || ''}
                         onChange={e => setAddPlateRow(prev => ({ ...prev, truckNumber: e.target.value }))}
                         placeholder="(optional)"
                         style={{ padding: '3px 6px', width: '12em' }} />
                </td></tr>
                <tr><td style={{ color: '#666' }}>From row</td><td className="small" style={{ color: '#666' }}>{addPlateRow.date} {addPlateRow.arrivalTime}</td></tr>
              </tbody>
            </table>
            {!addPlateRow.customer && (
              <div className="small" style={{ color: '#991b1b', marginBottom: '0.75rem' }}>
                Customer is required.
              </div>
            )}
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button className="refresh-btn"
                onClick={confirmAddPlate}
                disabled={addPlateBusy || !addPlateRow.customer || !addPlateRow.licensePlate}
                style={{ background: '#16a34a' }}>
                {addPlateBusy ? 'Adding…' : 'Add to registry'}
              </button>
              <button className="refresh-btn" onClick={() => setAddPlateRow(null)} disabled={addPlateBusy} style={{ background: '#888' }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
